// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "hooks-module--arrow-up-and-down--ea77a";
export var listPaginationMobileButton = "hooks-module--listPaginationMobileButton--c07b1";